import { t } from "@/global";
import { setAbPeersPassword } from "@/services/api";
import { API } from "@/services/typings";
import { ModalForm, ProFormItem, ProFormText } from "@ant-design/pro-form";
import { ActionType } from "@ant-design/pro-table";
import { Checkbox, message } from "antd";
import { useEffect, useState } from "react";

type SetPasswordProps = {
  visible: boolean;
  setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  actionRef: React.MutableRefObject<ActionType | undefined>;
  profile: API.SharedAbProfile;
  abPeers: API.AbPeer[];
}

const SetPasswordModal: React.FC<SetPasswordProps> = (props) => {
  const [removePassword, setRemovePassword] = useState(false);

  useEffect(() => {
    if (props.visible) {
      setRemovePassword(false);
    }
  }, [props.visible]);
  const handleUpdate = async (data: any) => {
    const hide = message.loading(t('Updating'));
    try {
      let password;
      if (removePassword) {
        password = '';
      } else {
        password = data.password;
      }
      const peer = {
        password: password,
        ab: props.profile.guid,
        ab_peers: props.abPeers.map((x) => x.guid),
      };
      let count = await setAbPeersPassword({ data: peer });
      hide();
      message.success(t(`${count} record${count > 1 ? 's' : ''} updated`));
      return true;
    } catch (error) {
      hide();
      message.error(
        typeof error == 'string' ? (error as string) : t('Update failed, please try again!'),
      );
      return false;
    }
  };

  return (
    <ModalForm
      title={t('set_password', true)}
      width="400px"
      open={props.visible}
      onOpenChange={props.setModalVisible}
      onFinish={async (values) => {
        const success = await handleUpdate(values);
        if (success) {
          if (props.actionRef.current) {
            props.actionRef.current?.reloadAndRest?.();
          }
          props.setModalVisible(false);
        }
      }}
      preserve={false}
      modalProps={{
        maskClosable: false,
        destroyOnClose: true,
        onCancel: () => {
          props.setModalVisible(false);
        },
      }}
    >
      {!removePassword && <ProFormText.Password
        fieldProps={{ autoComplete: 'new-password', maxLength: 128, type: 'password' }}
        rules={[
          {
            required: true,
            whitespace: false,
          }
        ]}
        width="md"
        name="password"
        label={t('New Password', true)}
      />}
      <ProFormItem>
        <Checkbox value={removePassword} onChange={(e) => setRemovePassword(e.target.checked)}>
          {t('Remove password', true)}
        </Checkbox>
      </ProFormItem>
    </ModalForm>
  )
}

export default SetPasswordModal;
